import { render } from "./InformationsListItem.vue?vue&type=template&id=be313dbc&scoped=true"
import script from "./InformationsListItem.vue?vue&type=script&lang=js"
export * from "./InformationsListItem.vue?vue&type=script&lang=js"

import "./InformationsListItem.vue?vue&type=style&index=0&id=be313dbc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be313dbc"

export default script